<template>
  <div>
    <h5>{{ getActor.name }}</h5>
    <div class="d-flex justify-content-center">
      <round-button :value="true" @click="turnOnAllVars" class="m-3" />
      <round-button :value="false" @click="turnOffAllVars" class="m-3" />
    </div>
  </div>
</template>

<script>
import ControlMixin from '@/components/service-groups/controls/controlMixin';
import RoundButton from '@/components/inputs/RoundButton';
import { mapGetters } from 'vuex';

export default {
  name: 'Button',
  components: { RoundButton },
  computed: {
    ...mapGetters([
      'getStatusVarByControlActorId',
    ]),
  },
  methods: {
    getVarsByValue(value) {
      return this.vars.filter((varItem) => {
        const statusVar = this.getStatusVarByControlActorId(varItem.actorId);
        if (statusVar !== null) {
          return statusVar.value === value;
        }
        return false;
      });
    },
    turnOffAllVars() {
      this.setVarsToValue(this.getVarsByValue(true), true);
    },
    turnOnAllVars() {
      this.setVarsToValue(this.getVarsByValue(false), true);
    },
  },
  mixins: [
    ControlMixin,
  ],
};
</script>

<style scoped>
</style>
